import validate from "/codebuild/output/src1547660482/src/ark/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45page_45view_45global from "/codebuild/output/src1547660482/src/ark/middleware/01.page-view.global.ts";
import _02_45referrer_45log_45global from "/codebuild/output/src1547660482/src/ark/middleware/02.referrerLog.global.ts";
import manifest_45route_45rule from "/codebuild/output/src1547660482/src/ark/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45page_45view_45global,
  _02_45referrer_45log_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  funnel: () => import("/codebuild/output/src1547660482/src/ark/middleware/funnel.ts")
}